import countryISOCodes from "components/dashboard/countryISOCodes.json";

// Country name → ISO alpha-2 code
export const countryToAlpha2 = new Map(countryISOCodes.map((c: any) => [c.country, c.alpha2]));

// Common name mismatches between various data sources and the ISO list
countryToAlpha2.set("North Macedonia", "MK");
countryToAlpha2.set("Ivory Coast", "CI");
countryToAlpha2.set("Timor-Leste", "TL");
countryToAlpha2.set("Eswatini", "SZ");
countryToAlpha2.set("Czech Republic", "CZ");
countryToAlpha2.set("Czechia", "CZ");
countryToAlpha2.set("United States of America", "US");
countryToAlpha2.set("USA", "US");
countryToAlpha2.set("Myanmar (Burma)", "MM");
countryToAlpha2.set("Republic of the Congo", "CG");
countryToAlpha2.set("Democratic Republic of the Congo", "CD");
countryToAlpha2.set("South Korea", "KR");
countryToAlpha2.set("North Korea", "KP");
countryToAlpha2.set("Palestine", "PS");
countryToAlpha2.set("Taiwan", "TW");
countryToAlpha2.set("Hong Kong", "HK");
countryToAlpha2.set("Macau", "MO");
countryToAlpha2.set("Curaçao", "CW");
countryToAlpha2.set("Curacao", "CW");
countryToAlpha2.set("Bonaire, Sint Eustatius and Saba", "BQ");
countryToAlpha2.set("Sint Maarten", "SX");
countryToAlpha2.set("Saint Martin", "MF");

// ISO alpha-2 → full country data (name, lat, lng, region, emoji, etc.)
export const alpha2ToCountryData = new Map<string, any>(
	countryISOCodes.map((c: any) => [c.alpha2, c])
);
